import { Button, Form } from "react-bootstrap";
import { LANG_CHOOSER_TYPES, LangChooser } from "../LangChooser";
import { SettingsLangChooserButton } from "../Modals/components/SettingsLangChooserButton";
import FormPasswordEye from "../../components/FormPasswordEye/FormPasswordEye";
import PasswordTooltip from "../../components/PasswordTooltip/PasswordTooltip";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import React, { useCallback } from "react";
import { connect } from "react-redux";
import { usePasswordTooltip } from "../../components/PasswordTooltip/passwordTooltipHooks";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";
import { createStructuredSelector } from "reselect";
import { getPadVersion, getPasswordMinLengthSelector, makeSelectAppFormError } from "../../app/appSelectors";
import { openModalAction, userUpdatePasswordAction } from "../../app/appActions";
import { SettingsContainerStyled, SettingsStyled } from "./styled/SettingsStyled";
import pjson from "../../../package.json";
import Cookies from "universal-cookie";

const cookies = new Cookies();

function Settings(props) {
    const {
        padVersion,
    } = props;
    const {getLangPath} = useLangContext();
    const {
        isShowPasswordTooltip, checkPasswordValue, onBlurPasswordField, onSelectPasswordField, onChangePasswordField,
    } = usePasswordTooltip();
    const {handleGTMClick} = useGTMEvent({module: 'Settings'});

    const {
        containersClassname,
        formError,
        onPasswordResetClick,
        onSuccessPasswordChangeCallback,
        passwordMinLength,
        userUpdatePassword,
    } = props;

    const formSubmitHandler = useCallback((e) => {
        e.preventDefault();
        userUpdatePassword({
            password: e.target.querySelector('[name=password]').value,
            passwordNew: e.target.querySelector('[name=password-new]').value,
            passwordNew2: e.target.querySelector('[name=password-new2]').value,
            callback: onSuccessPasswordChangeCallback,
        });
        handleGTMClick({button: 'change password'});
    }, [handleGTMClick, onSuccessPasswordChangeCallback, userUpdatePassword]);

    return <SettingsStyled>
        <SettingsContainerStyled className={containersClassname}>
            <Form.Group className="mb-3">
                <h6>{getLangPath('settings_modal.platform_language')}</h6>
            </Form.Group>

            <LangChooser
                className="w-100"
                toggleButtonComponent={SettingsLangChooserButton}
                type={LANG_CHOOSER_TYPES.dropdown}
                gtmModule="SettingsModal"
            />
        </SettingsContainerStyled>
        <SettingsContainerStyled className={containersClassname}>
            <Form onSubmit={formSubmitHandler}>
                <Form.Group className="mb-2">
                    <h6>{getLangPath('settings_modal.change_password')}</h6>
                </Form.Group>
                <Form.Group className={'mt-3'}>
                    <FormPasswordEye
                        name="password"
                        placeholder={getLangPath('settings_modal.current_password')}
                        isInvalid={formError}
                        required
                    />
                    {
                        formError === 'error.password_not_valid' && <>
                            <Form.Control.Feedback type="invalid">
                                <div className="d-flex justify-content-between align-items-center">
                                    <span>{getLangPath(onPasswordResetClick ? 'settings_modal.forgot_password' : 'error.password_not_valid')}</span>
                                    {
                                        !!onPasswordResetClick && <Button variant="link" onClick={onPasswordResetClick}
                                                                          className="color-white p-0">
                                            {getLangPath('settings_modal.reset_password')}
                                        </Button>
                                    }
                                </div>
                            </Form.Control.Feedback>
                        </>
                    }
                </Form.Group>
                <PasswordTooltip password={checkPasswordValue} show={isShowPasswordTooltip}>
                    <Form.Group className={'mt-4'}>
                        <FormPasswordEye
                            name="password-new"
                            placeholder={getLangPath('promo.fx.new_password.title')}
                            isInvalid={formError}
                            required
                            onSelect={onSelectPasswordField}
                            onBlur={onBlurPasswordField}
                            onChange={onChangePasswordField}
                        />
                    </Form.Group>
                </PasswordTooltip>
                <Form.Group className={'mt-3'}>
                    <FormPasswordEye name="password-new2" placeholder={getLangPath('promo.fx.new_password.text1')}
                                     isInvalid={formError} required/>
                    {
                        formError && formError !== 'error.password_not_valid' && <>
                            <Form.Control.Feedback type="invalid">
                                {getLangPath(formError, {count: passwordMinLength})}
                            </Form.Control.Feedback>
                        </>
                    }
                </Form.Group>
                <div className={'d-grid mt-4'}>
                    <Button variant={'info'} size={'md'} type="submit">
                        {getLangPath('settings_modal.change_password')}
                    </Button>
                </div>
            </Form>
        </SettingsContainerStyled>
        <SettingsContainerStyled>
            <span className="text-center f14 text-secondary">
                <div>pad {padVersion}</div>
                <div>fe {pjson.version}</div>
                {
                    cookies.get('app_version') && <div>app {cookies.get('app_version')}</div>
                }
            </span>
        </SettingsContainerStyled>
    </SettingsStyled>
}

const mapStateToProps = createStructuredSelector({
    formError: makeSelectAppFormError(),
    passwordMinLength: getPasswordMinLengthSelector,
    padVersion: getPadVersion,
});

const mapDispatchToProps = (dispatch) => ({
    openModal: (payload) => dispatch(openModalAction(payload)),
    userUpdatePassword: (payload) => dispatch(userUpdatePasswordAction(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
